// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"230b3b56","240":"eb0bce24","253":"f0b88e66","272":"230b3b56","343":"505804fe","420":"230b3b56","500":"643d08e1","570":"230b3b56","627":"650d94cd","708":"5d2d8dbc","804":"230b3b56","823":"74175e97","956":"5642dea2"}[chunkId] + ".chunk.css";
};